import { useMemo } from 'react';

import map from 'lodash/map';

import { usePositionsGet } from '@sbv-clients/data-access-api';
import { useProLaborLevelDesignations } from '@sbv-clients/data-access-api';
import { MultiSelect, useTransformSelectValue } from '@sbv-clients/ui-shared';

import { useAppendAllOption } from './util';
import useAutoSelectValue from './util/use-auto-select-value';

export function PositionsFilter({
  withAllOption = false,
  useContextFn,
  autoSelectIfEmpty = false,
  filteredByOpeningTemplates = true,
}: {
  withAllOption?: boolean;
  autoSelectIfEmpty?: boolean;
  useContextFn: () => {
    positions: number[];
    onPositionsChange: (value: number[]) => void;
  };
  filteredByOpeningTemplates?: boolean;
}) {
  const { positions: value, onPositionsChange: onChange } = useContextFn();

  const { data, isLoading, isSuccess } = usePositionsGet({
    filteredByOpeningTemplates: filteredByOpeningTemplates ?? true,
  });
  const options = useMemo(() => {
    return map(data, (item) => ({
      id: item.positionId,
      label: item.positionName ?? '',
      value: item.positionId,
    }));
  }, [data]);

  const { PositionLaborLevel } = useProLaborLevelDesignations();

  useAppendAllOption(options, withAllOption);

  const handleChange = useTransformSelectValue(onChange);
  useAutoSelectValue({
    value,
    options,
    selectFirstAsDefault: autoSelectIfEmpty,
    multiSelect: true,
    callback: (value) => {
      onChange([value]);
    },
    isSuccess,
  });

  return (
    <MultiSelect
      isLoading={isLoading}
      fullWidth
      options={options}
      size="small"
      value={isLoading ? [] : value}
      label={PositionLaborLevel}
      onChange={handleChange}
    />
  );
}
